// extracted by mini-css-extract-plugin
export default {"about":"AboutMeComponent_about__XfABu","container":"AboutMeComponent_container__akZsl","title":"AboutMeComponent_title__r-f7C","description":"AboutMeComponent_description__EkftP"};